export const DEFAULT_EMPTY_VALUE = '-';
